module.exports = __webpack_public_path__ + "static/img/top.3eda8e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/top.png
// module id = 574
// module chunks = 1